import { Img } from '@Components/Img';
import { CDN } from '@Components/MetricsTable/metrics-table-utils';

// Platform logo from the shared CDN (same convention as MetricsTable's `logo`
// columns) — falls back to the platform name when no logo asset exists. The
// `.dq-platform` styles are shared between the eligibility table and the modal,
// so they live in the two component roots (see ForecastDataQa.scss).
export const PlatformLogo = ({ platform }: { platform: string }) => (
  <span className='dq-platform' title={platform}>
    <Img
      src={`${CDN}/assets/img/platforms/${platform.replace(/\s+/g, '')}.png`}
      alt={platform}
      spinnerSize={12}
      unloader={<span>{platform}</span>}
    />
  </span>
);
